<template>
  <form :class="classes" @submit.prevent>
    <slot></slot>
  </form>
</template>
<script>
const PREFIXCLS = 'form'
export default {
  name: 'TForm',
  props: {
    model: {
      type: Object
    },
    rules: {
      type: Object
    },
    labelSpan: {
      type: [Number, String],
      default: 3
    },
    labelPosition: {
      type: String,
      validator(value) {
        return ['left', 'right', 'top'].includes(value)
      },
      default: 'top'
    },
    inline: {
      type: Boolean,
      default: false
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      validator(value) {
        return ['lg', 'sm'].includes(value)
      }
    }
  },
  data() {
    return {
      fields: []
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIXCLS}`,
        `${PREFIXCLS}--label-${this.labelPosition}`,
        {
          [`${PREFIXCLS}-inline`]: this.inline,
          [`${PREFIXCLS}--` + this.size]: !!this.size
        }
      ]
    }
  },
  watch: {
    rules() {
      // this.validate()
    }
  },
  created() {
    this.$on('on-form-item-add', field => {
      if (field) this.fields.push(field)
      return false
    })
    this.$on('on-form-item-remove', field => {
      if (field.prop) this.fields.splice(this.fields.indexOf(field), 1)
      return false
    })
  },
  methods: {
    resetFields() {
      this.fields.forEach(field => {
        field.resetField()
      })
    },
    validate(callback) {
      let valid = true
      let count = 0
      this.fields.forEach(field => {
        field.validate('', errors => {
          if (errors) {
            valid = false
          }
          if (
            typeof callback === 'function' &&
            ++count === this.fields.length
          ) {
            callback(valid)
          }
        })
      })
    },
    validateField(prop, cb) {
      const FIELD = this.fields.filter(FIELD => FIELD.prop === prop)[0]
      if (!FIELD) {
        throw new Error(
          '[taurus warn]: must call validateField with valid prop string!'
        )
      }
      FIELD.validate('', cb)
    }
  }
}
</script>



// WEBPACK FOOTER //
// form.vue?7488f3de